import { useMutation } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification.ts";
import { useSportConfiguration } from "~hooks/useSportConfiguration";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useImportSeasonOfficials = () => {
  const { sport = "", organizationId = "", seasonId = "" } = useParams();
  const { formatMessage } = useIntl();
  const request = useApi();
  const notification = useNotification();
  const { seasonOfficialRoles } = useSportConfiguration();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: (fileName) =>
      request(`${sport}/o/${organizationId}/seasons/${seasonId}/personRoles/import`, {
        method: "POST",
        body: {
          fileName,
          importName: "season officials",
          personRoles: seasonOfficialRoles,
        },
      }),
    onSuccess: async (response) => {
      if (response?.data?.[0]?.success) {
        notification.success({
          message: formatMessage({ id: "seasonOfficials.import.started" }),
          placement: "bottomRight",
        });
      }
    },
  });
};
